import React, { useEffect, useState } from "react";
import CardWithChart from "../../components/CardWithChart";
import CardWithChartComp from "../../components/CardWithChartComp";
import CardWithLineChart from "../../components/CardWithLineChart";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboardListingData,
  fetchHeatMapData,
} from "../../redux/slice/DashboardListingSlice";
import "./Dashboard.css";
import StackedBarChart from "../../components/StackedBarChart";
import KitInstalledChart from "../../components/KitInstalledChart";
import QuotesGenerated from "../../components/QuotesGenerated";
import IncidentDetails from "../../components/IncidentDetails";
import InstalledKitsLocationChart from "../../components/InstalledKitsLocationChart";
import { successStatusCode } from "../../utils/constants";

function Dashboard() {
  const dispatch = useDispatch();
  const [dataFetched, setDataFetched] = useState(false);
  const [kitsInstalledLocation, setKitsInstalledLocation] = useState([]);
  const [reportedIncidentsLocation, setReportedIncidentsLocation] = useState(
    []
  );
  const { DashboardListingData } = useSelector(
    (state) => state.DASHBOARDLISTING
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchDashboardListingData());
        const res = await dispatch(fetchHeatMapData());
        if (res?.payload?.status === successStatusCode) {
          setKitsInstalledLocation(
            res?.payload?.data?.heatMapDataToRegisteredKit ?? []
          );
          setReportedIncidentsLocation(
            res?.payload?.data?.heatMapDataToReportedIncident ?? []
          );
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setDataFetched(true);
      }
    };

    fetchData();
  }, [dispatch]);

  if (!dataFetched) {
    return <Loader />;
  }

  return (
    <div className="d-flex flex-column row-gap-3 row-gap-sm-4">
      <div className="row dashbaord_top_row row-gap-3 row-gap-sm-4">
        <div className="col-md-6 col-xxl-4">
          <CardWithChart title={"Registered Users"} />
        </div>
        <div className="col-md-6 col-xxl-4">
          <CardWithChartComp title={"Registered Companies"} />
        </div>
        <div className="col-12 col-xxl-4">
          <QuotesGenerated title={"Quotes Generated"} />
        </div>
        <div className="col-12 col-xl-8">
          <div className="row row-gap-3 row-gap-sm-4 h-100">
            <div className="col-12">
              <CardWithLineChart
                style={{ fontSize: 20, fontWeight: 500 }}
                className=""
              />
            </div>
            <div className="col-12 col-xxl-6">
              <div
                className="bg-white p-3 h-100"
                style={{ borderRadius: "16px" }}
              >
                <KitInstalledChart />
              </div>
            </div>
            <div className="col-12 col-xxl-6">
              <IncidentDetails />
            </div>
            <div className="col-sm-12">
              <StackedBarChart
                colors={["#FA0000", "#FAA500", "#359742"]}
                data={DashboardListingData?.data?.incident_data}
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-4">
          <div className="row h-100 row-gap-3 row-gap-sm-4">
            <div className="col-12 report-chart-sec">
              <InstalledKitsLocationChart
                title="Installed Kits"
                data={kitsInstalledLocation}
              />
            </div>
            <div className="col-12 report-chart-sec">
              <InstalledKitsLocationChart
                title="Reported Incidents"
                data={reportedIncidentsLocation}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
